module.exports = __webpack_public_path__ + "img/discord.3437c105.svg";